import { NgModule } from '@angular/core';
import { LoadingModule } from '@organisms/loading/loading.module';
import { CallbackComponent } from './callback.component';

@NgModule({
  imports: [LoadingModule],
  declarations: [CallbackComponent]
})
export class CallbackModule {}
